.content-container {
    background-color: var(--white);
    margin: 12px;
    height: calc(100% - 24px);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.animation-container {
    width: 400px;
    height: 300px;
    border-radius: 16px;
    overflow: hidden;
}

.action-container {
    width: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
}
